import { render, staticRenderFns } from "./PerhitunganKinerja.vue?vue&type=template&id=53b9d60d&scoped=true&lang=html&"
import script from "./PerhitunganKinerja.vue?vue&type=script&lang=js&"
export * from "./PerhitunganKinerja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b9d60d",
  null
  
)

export default component.exports